import React from 'react'
import { VERTICAL } from 'lib/utils/store/vehicle'
import { logException } from 'lib/errors'

import LogoAlmaWhite from 'images/svg/logos/logo_alma_white.svg'
import LogoAlmaBlack from 'images/svg/logos/logo_alma_black.svg'
import LogoAlmaAjoWhite from 'images/svg/logos/logo_almaajo_white.svg'
import LogoAlmaAjoBlack from 'images/svg/logos/logo_almaajo_black.svg'
import LogoAlmaAjoTwoLineWhite from 'images/svg/logos/Logo_alma_ajo_two_line_white.svg'

import LogoNettiauto from 'images/svg/logos/NETTIAUTO-logo-MUSTA.svg'
import LogoNettiautoWhite from 'images/svg/logos/NETTIAUTO-logo-NEGA.svg'
import LogoNettimoto from 'images/svg/logos/NETTIMOTO-logo-MUSTA.svg'
import LogoNettimotoWhite from 'images/svg/logos/NETTIMOTO-logo-NEGA.svg'
import LogoNettikone from 'images/svg/logos/NETTIKONE-logo-MUSTA.svg'
import LogoNettikoneWhite from 'images/svg/logos/NETTIKONE-logo-NEGA.svg'
import LogoNettivene from 'images/svg/logos/NETTIVENE-logo-MUSTA.svg'
import LogoNettiveneWhite from 'images/svg/logos/NETTIVENE-logo-NEGA.svg'
import LogoNettivaraosa from 'images/svg/logos/NETTIVARAOSA-logo-MUSTA.svg'
import LogoNettivaraosaWhite from 'images/svg/logos/NETTIVARAOSA-logo-NEGA.svg'
import LogoNettikaravaani from 'images/svg/logos/NETTIKARAVAANI-logo-MUSTA.svg'
import LogoNettikaravaaniWhite from 'images/svg/logos/NETTIKARAVAANI-logo-NEGA.svg'
import LogoNettimokki from 'images/svg/logos/NETTIMOKKI-logo-MUSTA.svg'
import LogoNettimokkiWhite from 'images/svg/logos/NETTIMOKKI-logo-NEGA.svg'
import LogoNettivuokraus from 'images/svg/logos/NETTIVUOKRAUS-logo-MUSTA.svg'
import LogoNettivuokrausWhite from 'images/svg/logos/NETTIVUOKRAUS-logo-NEGA.svg'
import LogoRekkari from 'images/logos/rekkari-logo.png'

export const getAlmaAjoLogo = (returnRendered = true, variant = 'black', isDeviceMobile = false) => {
    let Logo = null
    switch (variant) {
    case 'black':
        Logo = LogoAlmaAjoBlack
        break
    case 'white':
        Logo = isDeviceMobile ? LogoAlmaAjoTwoLineWhite : LogoAlmaAjoWhite
        break
    default:
        logException(`Invalid logo variant ${variant}`)
        return null
    }

    return returnRendered ? <Logo alt="Alma Ajo logo" /> : Logo
}

export const getAlmaLogo = (returnRendered = true, variant = 'black') => {
    let Logo = null
    switch (variant) {
    case 'black':
        Logo = LogoAlmaBlack
        break
    case 'white':
        Logo = LogoAlmaWhite
        break
    default:
        logException(`Invalid logo variant ${variant}`)
        return null
    }

    return returnRendered ? <Logo alt="Alma logo" /> : Logo
}

export const getVerticalLogo = (vertical, returnRendered = true, variant = 'black') => {
    let Logo = null

    switch (variant) {
    case 'black':
        switch (vertical) {
        case VERTICAL.CARAVAN:
            Logo = LogoNettikaravaani
            break
        case VERTICAL.PART:
            Logo = LogoNettivaraosa
            break
        case VERTICAL.BOAT:
            Logo = LogoNettivene
            break
        case VERTICAL.MACHINE:
            Logo = LogoNettikone
            break
        case VERTICAL.BIKE:
            Logo = LogoNettimoto
            break
        case VERTICAL.CAR:
            Logo = LogoNettiauto
            break
        case VERTICAL.RENT:
            Logo = LogoNettivuokraus
            break
        case VERTICAL.CABIN:
            Logo = LogoNettimokki
            break
        default:
            logException(`Invalid logo. variant: ${variant} vertical: ${vertical}`)
        }
        break
    case 'white':
        switch (vertical) {
        case VERTICAL.BIKE:
            Logo = LogoNettimotoWhite
            break
        case VERTICAL.CAR:
            Logo = LogoNettiautoWhite
            break
        case VERTICAL.BOAT:
            Logo = LogoNettiveneWhite
            break
        case VERTICAL.MACHINE:
            Logo = LogoNettikoneWhite
            break
        case VERTICAL.CARAVAN:
            Logo = LogoNettikaravaaniWhite
            break
        case VERTICAL.PART:
            Logo = LogoNettivaraosaWhite
            break
        case VERTICAL.RENT:
            Logo = LogoNettivuokrausWhite
            break
        case VERTICAL.CABIN:
            Logo = LogoNettimokkiWhite
            break
        default:
            logException(`Invalid logo. variant: ${variant} vertical: ${vertical}`)
        }
        break
    default:
        logException(`Invalid log variant. variant: ${variant}`)
    }

    if (!Logo) return null

    return returnRendered ? <Logo alt={`${vertical} logo`} /> : Logo
}

export const getAllVerticalLogos = (returnRendered = true) => {
    return Object.values(VERTICAL).map(vertical => getVerticalLogo(vertical, returnRendered))
}

export const RekkariLogo = (props) => {
    return <img src={LogoRekkari} alt="rekkari.fi logo" {...props} />
}
